import {useTranslation} from 'next-i18next'
import {Box, Text} from '@chakra-ui/react'

export const EmptyCartInfo = () => {
  const { t } = useTranslation('cart')
  return (
    <Box>
      <Text
        my={{
          base: 4,
          lg: 6,
        }}
      >
        {t('EMPTY_CART')}
      </Text>
    </Box>
  )
}
